import { MdOutlineSettingsSuggest, MdPayment } from "react-icons/md";
import useGetCompanyData from "views/hooks/useGetCompanyData";
import Features from "../components/Features/Features";
import Identity from "../components/Identity/Identity";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import Payment from "../components/Payments/Payment";
import Formats from "../components/Formats/Formats";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useGeneralApi from "./useGeneralApi";
import { FaUserAlt } from "react-icons/fa";
import { useEffect } from "react";

export default function useGeneralTabs() {
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();

  const {
    mainAddress,
    listAddresses,
    getCompanySetting,
    refetchGetCompanySetting,
    companySettingLoading,
    addressesLoading,
  } = useGeneralApi();
  const { getCompany, loading, refetch } = useGetCompanyData();

  useEffect(() => {
    if (urlParams?.companyId) {
      getCompany({
        variables: {
          id: urlParams.companyId,
        },
      });
      getCompanySetting({
        variables: {
          id: urlParams?.companyId,
        },
      });

      listAddresses({
        variables: {
          filter: { company_In: urlParams?.companyId, addressType: "main" },
          limit: 10,
          offset: 0,
        },
      });
    }
  }, [urlParams.companyId]);

  return [
    {
      key: "identity",
      label: (
        <span className="tab-icon-container">
          <FaUserAlt />
          {t("Identity")}
        </span>
      ),
      children: (
        <Identity
          loading={loading || addressesLoading}
          mainAddress={mainAddress}
          refetch={refetch}
        />
      ),
    },
    {
      key: "payment-settings",
      label: (
        <span className="tab-icon-container">
          <MdPayment />
          {t("Payment")}
        </span>
      ),
      children: (
        <Payment refetch={refetchGetCompanySetting} loading={loading || companySettingLoading} />
      ),
    },
    {
      key: "formats",
      label: (
        <span className="tab-icon-container">
          <MdOutlineSettingsSuggest />
          {t("Formats")}
        </span>
      ),
      children: (
        <Formats refetch={refetchGetCompanySetting} loading={loading || companySettingLoading} />
      ),
    },
    {
      key: "features",
      label: (
        <span className="tab-icon-container">
          <AiOutlineMenuUnfold />
          {t("Features")}
        </span>
      ),
      children: <Features loading={loading} />,
    },
  ];
}
